import AdminOperationsScreen from "../../src/features/arrangements/screens/AdminOperationsScreen";

export default function FormTemplateEditorRoute() {
  return <AdminOperationsScreen screenIdOverride="form-template-editor" />;
}
